import { graphql } from '../gql';

export const getVendorAvailability = graphql(`
  query GetVendorAvailability($input: GetVendorAvailabilityInput!) {
    getVendorAvailability(input: $input) {
      error {
        code
        message
      }
      availability {
        dates {
          date
          available
        }
        mealPeriods {
          breakfast
          lunch
          dinner
          appetizers
        }
        eligibleMealPeriods {
          breakfast
          lunch
          dinner
          appetizers
        }
        submission {
          submittedAt
          submittedByEmail
          version
        }
        submissionStatus
        windowStatus
        deadlineDate
        requiresSubmission
      }
    }
  }
`);
